// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"ImageCarouselModule_carouselContainer__3OSBH","carouselName":"ImageCarouselModule_carouselName__ykcz4","imageColumn":"ImageCarouselModule_imageColumn__1HXRH"};